import { Flex, Skeleton } from 'antd'
import { BudgetCoinLoader } from 'src/pages/budget/components'

export const RowSkeleton = () => {
  const { Input, Button } = Skeleton
  return (
    <Flex align="center" gap={16}>
      <BudgetCoinLoader />
      {[1, 2, 3].map((item) => (
        <Button key={item} style={{ width: 100 }} />
      ))}
      <Input />
    </Flex>
  )
}
